import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type WorkforceHorizontalNavEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const workforceHorizontalNavEntryPoint: EntryPoint<
	WorkforceHorizontalNavEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<WorkforceHorizontalNavEntryPointComponent>(
		/* webpackChunkName: "async-workforce-horizontal-nav", jiraSpaEntry: "async-workforce-horizontal-nav" */ './WorkforceHorizontalNav.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({
		queries: {},
		entryPoints: {},
		extraProps: {},
	}),
});
